import type { PropsWithChildren } from 'react';
import { useField } from 'remix-validated-form';
import type { Props as BlockProps } from '@shared/components/ui/Block';
import Block from '@shared/components/ui/Block';
import styled from 'styled-components';
import { Text } from '../Text';

function useOptionalField(name: string): { error: string | undefined } {
    try {
        return useField(name);
    } catch (e) {
        return { error: undefined };
    }
}

export type Props = PropsWithChildren<
    BlockProps & {
        name: string;
    }
>;

export function RadioGroup({ name, children, ...props }: Props) {
    const { error } = useOptionalField(name);

    return (
        <Block {...props}>
            <FieldSet
                as="fieldset"
                $align="left"
                $gap={20}
                spacing={error ? 'small' : undefined}
            >
                {children}
            </FieldSet>

            {error && (
                <Text color="red" size="xSmall">
                    {error}
                </Text>
            )}
        </Block>
    );
}

const FieldSet = styled(Block)`
    border: none;
    padding: 0;
`;
